module.exports = __webpack_public_path__ + "img/patent3.76ed1ff4.jpg";